/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateSestMaintenanceScheduleRequest = {
  /**
   * puid
   */
  puid: string;
  /**
   * 유저설정 기준 주행거리
   */
  customStdDistance?: number;
  /**
   * 유저설정 기준 일 수
   */
  customStdDays?: number;
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DAY)
   */
  maintenanceType?: UpdateSestMaintenanceScheduleRequest.maintenanceType;
  /**
   * OWNER_MANUAL, CUSTOM
   */
  stdType?: UpdateSestMaintenanceScheduleRequest.stdType;
};
export namespace UpdateSestMaintenanceScheduleRequest {
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DAY)
   */
  export enum maintenanceType {
    COMBINED = 'COMBINED',
    DISTANCE = 'DISTANCE',
    DAY = 'DAY',
  }
  /**
   * OWNER_MANUAL, CUSTOM
   */
  export enum stdType {
    OWNER_MANUAL = 'OWNER_MANUAL',
    CUSTOM = 'CUSTOM',
  }
}

